/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditDowntimeEntry } from '../../models/edit-downtime-entry';

export interface EditDowntime$Params {
  downtimeId: number;
      body: EditDowntimeEntry
}

export function editDowntime(http: HttpClient, rootUrl: string, params: EditDowntime$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, editDowntime.PATH, 'post');
  if (params) {
    rb.path('downtimeId', params.downtimeId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

editDowntime.PATH = '/api/v1/Downtimes/{downtimeId}/EditDowntime';
